export default __webpack_public_path__ + "static/6914-27176dd0769afcfb15649af0196b2bb1.jpg";